import React, {useContext, useEffect, useState} from 'react';
import {Dropdown, Form, Spinner} from "react-bootstrap";
import {createLanguage, updateLanguage, delLanguage, fetchLanguages} from "../../../http/bookAPI";
import Modal from "react-bootstrap/Modal";
import {Context} from "../../../index";
import {observer} from "mobx-react-lite";

const UpdateLanguage = observer(({ show, handleClose }) => {
    const {book} = useContext(Context)
    const [value, setValue] = useState('');
    const [value_sh, setValueSh] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchLanguages().then(data => book.setLanguages(data))
    }, []);

    const modifyLanguage = async () => {
        if (!book.selectedLanguage.id) {
            setError('Please select a language to modify.');
            return;
        }

        setLoading(true);
        setError('');
        try {
            // Логируем id и данные, которые отправляются в запросе
            console.log('Genre data being sent:', { id: book.selectedLanguage.id, language: value, language_short: value_sh });
            await updateLanguage({
                id: book.selectedLanguage.id, // Используем выбранный язык
                language: value,//// Новое название языка
                language_short: value_sh //// Новое название языка


            });
            const updatedLanguage = await fetchLanguages(); // Обновляем список жанров после изменения
            book.setLanguages(updatedLanguage);
            book.setSelectedLanguage({}); // Сбрасываем выбранный жанр
            setValue(''); // Очищаем поле ввода
            setValueSh(''); //ем поле ввода
            handleClose(); // Закрываем модальное окно
        } catch (e) {
            const errorMessage = e.response?.data?.message || 'An error occurred while modifying the language.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };


    return (
        <Modal show={show} onHide={() => {
            setError('');
            handleClose();
        }} centered>

            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Edit Language</h1>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                    ></button>
                </div>

                <div className="card">
                    <div className="card-body">

                        <div className="d-flex justify-content-center mt-3">

                            <Dropdown className="dropdown-center">
                                <Dropdown.Toggle variant="success" className="shadow">
                                    {book.selectedLanguage.language || "Select Language to Modify"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {book.languages.map((lan) => (
                                        <Dropdown.Item
                                            onClick={() => {
                                                book.setSelectedLanguage(lan);
                                                setValue(lan.language);
                                                setValueSh(lan.language_short);
                                            }}
                                            key={lan.id}
                                        >
                                            {lan.language}

                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
                <div className="small ms-3 mt-3 mb-0 p-0"> Update a full name of Language:</div>
                <div className="modal-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <Form>
                        <Form.Control
                            value={value}
                            onChange={(e) => setValue(e.target.value)}

                            disabled={loading || !book.selectedLanguage.language} // Отключаем, если ничего не выбрано
                        />
                    </Form>
                </div>
                <div className="small ms-3 mt-0 mb-0 p-0"> Update a short name of Language:</div>
                <div className="modal-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <Form>
                        <Form.Control
                            value={value_sh}
                            onChange={(e) => setValueSh(e.target.value)}
                            disabled={loading || !book.selectedLanguage.language} // Отключаем, если ничего не выбрано

                        />
                    </Form>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                        disabled={loading}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={modifyLanguage}
                        disabled={!value.trim() || loading}
                    >
                        {loading ? <Spinner as="span" animation="border" size="sm"/> : 'Rewrite in DB'}
                    </button>

                </div>
            </div>
        </Modal>
    );
});

export default UpdateLanguage;